import React from 'react'
import {
  DescriptionPara,
  TableData,
  TableRow,
  TableCol,
  ContentPara,
  SpacedRow,
  ColWrapper,
  Ahref,
  TableModal,
  ProgressCircle,
  ProgressLabelContainer,
  ProgressLabel,
  ProgressValue,
  CashSquare,
  StockSquare,
  ProgressUpdated
} from "./stylesNew";
import TooltipComponent from '../../../../../../CommonComponents/Info/Tooltip/TooltipComponent';
import ClipDivision from "../../../../../../CommonComponents/ClipDivison/ClipDivision";
import { GhostButtonComponent, DataHeading, DataValue, DisplayFlex } from '../../../../../../CommonComponents/commonStyles';
import { recordError } from "../../../../../../utils/commonUtil";
import GlobalModal from "../../../../../../CommonComponents/AlertModal/GlobalModal";

export const poolType = (type) => {
  switch (type) {
    case "Values-driven Investments":
      return "vdi";
      break;
    case "Portfolio Builders":
      return "pb";
      break;
    case "Portfolio Solutions":
      return "ps";
      break;
    default: return -1;
      break;
  }
};


var totalReturn = [];
export default function FundModal(props) {
  const { visible, poolData, poolUf, cancelOptionModal } = props;
  totalReturn = poolUf.length> 0 && poolUf.filter(item => { return item.field_total == "Yes" });
  const getAlert = (e,link) => {
    try {
      e.preventDefault();
      let newLink = link.substr(9, link.indexOf('" target') - 9);
      GlobalModal({ 
        handleOk: ()=>{ window.open(newLink, "_blank")}, 
        contents: "Clicking OK will open a new window to Vanguard.com, a website that is not hosted by Vanguard Charitable.",
        handleCancel: ()=>{ return false },
        type: "confirm"
      });
    } catch (error) {
      recordError(error);
    }
  }
  return (
    <>
      {visible == false ? <></> :
        <TableModal
         data-test="modal"
          title={poolData[0].title}
          visible={visible}
          onCancel={() => cancelOptionModal(false)}
          width={1180}
          footer={<div class="flex items-center">
            <GhostButtonComponent data-test="btn" width="200px" onClick={() => cancelOptionModal(false)}>CLOSE</GhostButtonComponent>
          </div>}
        >
          <DescriptionPara dangerouslySetInnerHTML={{ __html: poolData[0].field_description }}></DescriptionPara>
          <TableRow>
            <TableCol colWidth="15%">
              <TableData> Expense Ratio </TableData>
              <SpacedRow smJustifyStart>
                <div>
                  <DataHeading> Standard </DataHeading>
                  <DataValue> {Number(poolUf[0].field_expense_ratio_standard) != 0 ? <>{poolUf[0].field_expense_ratio_standard}% </> : <>&mdash;</>}</DataValue>
                </div>
                <ColWrapper>:</ColWrapper>
                <div>
                  <DataHeading> Select </DataHeading>
                  <DataValue> {Number(poolUf[0].field_expense_ratio_select) != 0 ? <>{poolUf[0].field_expense_ratio_select}% </> : <>&mdash;</>}</DataValue>
                </div>
              </SpacedRow>
            </TableCol>

            <TableCol colWidth="24%">
              <TableData> Risk/granting time horizon</TableData>
              <ClipDivision
                risk={poolData[0].field_risk_granting}
                tab={poolType(poolData[0].field_investment_type)}
              />
            </TableCol>

            <TableCol colWidth="30%">
              <TableData> Returns <TooltipComponent text={poolData[0].field_returns_updated_date}></TooltipComponent></TableData>
              <SpacedRow >
                <div>
                  <DataHeading>Qtr</DataHeading>
                  <DataValue> {Number(totalReturn[0].field_returns_ytd) != 0 ? <>{totalReturn[0].field_returns_ytd}% </> : <>&mdash;</>}</DataValue>
                </div>
                <div>
                  <DataHeading>1 Yr</DataHeading>
                  <DataValue>{Number(totalReturn[0].field_returns_1_yr) != 0 ? <>{totalReturn[0].field_returns_1_yr}% </> : <>&mdash;</>}</DataValue>
                </div>
                <div>
                  <DataHeading>5 Yrs</DataHeading>
                  <DataValue>{Number(totalReturn[0].field_returns_5_yrs) != 0 ? <>{totalReturn[0].field_returns_5_yrs}% </> : <>&mdash;</>}</DataValue>
                </div>
                <div>
                  <DataHeading>10 Yrs</DataHeading>
                  <DataValue>{Number(totalReturn[0].field_returns_10_yrs) != 0 ? <>{totalReturn[0].field_returns_10_yrs}% </> : <>&mdash;</>}</DataValue>
                </div>
              </SpacedRow>
            </TableCol>
            {poolData[0].field_investment_type === "Portfolio Solutions" ?
              <TableCol colWidth="30%">
                <TableData>Target Allocation</TableData>
                <DisplayFlex>
                  <ProgressCircle>
                    <ProgressUpdated
                      type="circle"
                      percent={parseFloat(poolData[0].field_target_allocation_value_1)}
                      format={() => ""}
                      strokeWidth={10}
                      width={56}
                      strokeLinecap="square"
                      strokeColor={"#0098db"}
                    />
                  </ProgressCircle>
                  <ProgressLabelContainer>
                    <DisplayFlex className="mb-xs-1">
                      <CashSquare />
                      <DisplayFlex>
                        <ProgressValue>{Number(poolData[0].field_target_allocation_value_1) != 0 ? <>{poolData[0].field_target_allocation_value_1}% </> : <>&mdash;</>}</ProgressValue>
                        <ProgressLabel>{poolData[0].field_target_allocation_label_1 !== "" ? <>{poolData[0].field_target_allocation_label_1} </> : <>&mdash;</>}</ProgressLabel>
                      </DisplayFlex>
                    </DisplayFlex>
                    <DisplayFlex>
                      <StockSquare />
                      <DisplayFlex>
                        <ProgressValue>{Number(poolData[0].field_target_allocation_value_2) != 0 ? <>{poolData[0].field_target_allocation_value_2}% </> : <>&mdash;</>}</ProgressValue>
                        <ProgressLabel>{poolData[0].field_target_allocation_label_2 !== "" ? <>{poolData[0].field_target_allocation_label_2} </> : <>&mdash;</>}</ProgressLabel>
                      </DisplayFlex>
                    </DisplayFlex>
                  </ProgressLabelContainer>
                </DisplayFlex>
              </TableCol> :
              <TableCol colWidth="30%">
                <TableData>Underlying Fund</TableData>
                <ContentPara boldText>
                  {poolUf.map(item => {
                    if (item.field_total !== "Yes" && !item.field_fund.includes("Benchmark Return"))
                      return (
                        <DisplayFlex>
                          <DataValue>{Number(item.field_funds_percentage) != 0 ? <>{parseFloat(item.field_funds_percentage).toFixed(0)}% </> : <>&mdash;</>}</DataValue>
                          <Ahref 
                            data-test="ahref"
                            onClick={(event) => getAlert(event, item.field_fund)}
                            dangerouslySetInnerHTML={{ __html: item.field_fund }}
                          ></Ahref>
                        </DisplayFlex>
                      )
                  }
                  )}
                </ContentPara>
              </TableCol>}
          </TableRow>

          {/** Second Row **/}
          <TableRow margin>
            {poolData[0].field_investment_type === "Portfolio Solutions" ?
              <>
                <TableCol colWidth="39%">
                  <TableData>Underlying Fund</TableData>
                  <ContentPara boldText>
                    {poolUf.map(item => {
                      if (item.field_total !== "Yes" && !item.field_fund.includes("Benchmark Return"))
                        return (
                          <DisplayFlex>
                            <DataValue>{Number(item.field_funds_percentage) != 0 ? <>{parseFloat(item.field_funds_percentage).toFixed(0)}% </> : <>&mdash;</>}</DataValue>
                            <Ahref
                             data-test = "link"
                              onClick={(event) => getAlert(event, item.field_fund)}
                              dangerouslySetInnerHTML={{ __html: item.field_fund }}></Ahref>
                          </DisplayFlex>
                        )
                    }
                    )}
                  </ContentPara>
                </TableCol>
                <TableCol colWidth="30%">
                  <TableData>Management <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager’s selections. Passive funds seek to mimic benchmarks by tracking an index." /></TableData>
                  <ContentPara lightText> {poolData[0].field_management} </ContentPara>
                </TableCol>
                <TableCol colWidth="30%">
                  <TableData>Goal</TableData>
                  <ContentPara>
                    <DataHeading dangerouslySetInnerHTML={{ __html: poolData[0].field_goal }}></DataHeading>
                  </ContentPara>
                </TableCol>
              </> :
              <>
                <TableCol colWidth="15%">
                  <TableData>Benchmark</TableData>
                  <ContentPara >
                    {/*data from API is a string which contains “<p>content</p>“ 
                so when we add it it is rendered as a text with <p>content</p>. 
                That’s why using dangerouslySetInnerHTML. */}
                    {poolData[0].field_benchmark ? <DataHeading dangerouslySetInnerHTML={{ __html: poolData[0].field_benchmark }}></DataHeading> : <>&mdash;</>}
                  </ContentPara>
                </TableCol>

                <TableCol colWidth="24%">
                  <TableData>Management <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager’s selections. Passive funds seek to mimic benchmarks by tracking an index." /></TableData>
                  {poolData[0].field_management ? <ContentPara lightText> {poolData[0].field_management} </ContentPara> : <>&mdash;</>}
                </TableCol>
                <TableCol colWidth="60%">
                  <TableData>Goal</TableData>
                  <ContentPara>
                    {poolData[0].field_goal ? <DataHeading dangerouslySetInnerHTML={{ __html: poolData[0].field_goal }}></DataHeading> : <>&mdash;</>}
                  </ContentPara>
                </TableCol>
              </>
            }
          </TableRow>
        </TableModal>
      }
    </>
  )
}